import { http } from "../http.js";
async function getSavedFilters(id) {
  const response = await http.get(`saved-filters/${id}`);
  return response;
}

export { getSavedFilters };
